export interface PaymentMethodZelle {
  selecionado: boolean;
  nomeCompleto: string;
  emailOuTelefone: string;
  nomeBanco: string;
}

export interface PaymentMethodBankAccount {
  selecionado: boolean;
  nomeBanco: string;
  titularConta: string;
  codigoBanco: string;
  numeroConta: string;
}

export interface PaymentMethodInternationalAccount {
  selecionado: boolean;
  nomeBanco: string;
  codigoSwift: string;
  numeroConta: string;
  iban: string;
  titularConta: string;
}

export interface PaymentMethod {
  id?: string;
  motoristaId: string;
  ssn?: string;
  taxId?: string;
  zelle?: PaymentMethodZelle;
  contaBancaria?: PaymentMethodBankAccount;
  contaInternacional?: PaymentMethodInternationalAccount;
  metodoSelecionado?: 'Zelle' | 'ContaBancaria' | 'ContaInternacional';
}

export type PaymentMethodType = 'Zelle' | 'ContaBancaria' | 'ContaInternacional';

export const PaymentMethodTypeLabels: Record<PaymentMethodType, string> = {
  'Zelle': 'Zelle',
  'ContaBancaria': 'Bank Account',
  'ContaInternacional': 'International Account'
};
